var React = require('react');

function FreezoneDownloadButton (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M17 19.8698L13.8391 16.7107M17 19.8698L20.1609 16.7107M17 19.8698V10.3889M24.1111 21.4502C24.1111 22.2885 23.7781 23.0925 23.1853 23.6853C22.5925 24.2781 21.7885 24.6111 20.9502 24.6111H13.0498C12.2115 24.6111 11.4075 24.2781 10.8147 23.6853C10.2219 23.0925 9.88889 22.2885 9.88889 21.4502M33 17.5C33 26.3366 25.8366 33.5 17 33.5C8.16344 33.5 1 26.3366 1 17.5C1 8.66344 8.16344 1.5 17 1.5C25.8366 1.5 33 8.66344 33 17.5Z","stroke":"#CE445B","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

FreezoneDownloadButton.defaultProps = {"width":"34","height":"35","viewBox":"0 0 34 35","fill":"none"};

module.exports = FreezoneDownloadButton;

FreezoneDownloadButton.default = FreezoneDownloadButton;
